import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { AuthContext } from "../../context/AuthContext";
import { useTheme } from "../../context/ThemeContext";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import VantaBackground from "../VantaBackground";
import i18n from "../../i18n";
import { rememberDastDestination } from "../../scripts/authSession";

export default function Login() {
  const { apiUrl, login } = useContext(AuthContext);
  const { theme } = useTheme();
  const queryClient = useQueryClient();
  const [loginStatus, setLoginStatus] = useState(null);
  const [urlError, setUrlError] = useState(null);
  const { t } = useTranslation();

  // Permet de définir la langue du site via un toggle
  useEffect(() => {
    const currentLanguage = window.localStorage.getItem("langue");

    if (currentLanguage === null) i18n.changeLanguage("fr")

    if (currentLanguage === "en") {
      i18n.changeLanguage("en")
    } else {
      i18n.changeLanguage("fr")
    }
    const urlParams = new URLSearchParams(window.location.search);
    const error = urlParams.get("error");
    if (error) {
      setUrlError(decodeURIComponent(error));
    }
  }, [])

  //Validation de l'email via Yup
  const ValidationSchema = Yup.object().shape({
    username: Yup.string()
      .required("Merci de saisir votre email")
      .email("Merci de saisir un email valide"),

    password: Yup.string().required("Merci de saisir votre mot de passe"),
  });

  const { register, handleSubmit, formState: { errors }, setError } = useForm({
    mode: "onBlur",
    resolver: yupResolver(ValidationSchema),
  });

  const loginFn = async (data) => {
    try {
      const res = await axios.post(`${apiUrl}api/login_check`, data, {
        withCredentials: true,
      });
      await login(res.data.token);
      setLoginStatus(null);
    } catch (error) {
      console.error("Erreur de connexion:", error);
      setLoginStatus(error);
    }
  };


  const loginForm = useMutation({
    mutationFn: (data) => loginFn(data),
    onSuccess: () => {
      queryClient.invalidateQueries(["user"]);
    }
  });

  const handleInputChange = () => setLoginStatus(null);

  const handleMicrosoftLogin = () => {
    rememberDastDestination();
    window.location.href = `${apiUrl}connect_microsoft/`;
  };

  return (
      <article className="login-container">
        {/* <VantaBackground /> */}
        <section className="page-login">
          <h1 className="page-login_title">Elit customer Portal</h1>
          <form
            className="form form-login"
            onSubmit={handleSubmit(loginForm.mutate)}
          >
            <div className="form-input_container" onChange={handleInputChange}>
              <label htmlFor="email">E-mail</label>
              <input type="email" id="email" {...register("username")} />
              {errors.username && (
                <small className="error">{t(errors.username?.message)}</small>
              )}
            </div>
            <div className="form-input_container" onChange={handleInputChange}>
              <label htmlFor="password">{t("Mot de passe")}</label>
              <input type="password" id="password" {...register("password")} autoComplete="on" />
              {errors.password && (
                <small className="error">{t(errors.password?.message)}</small>
              )}
            </div>
            <button type="submit" className="button button-new">
              {t("Connexion")}
            </button>
            <div className="separator-login-check">
              <span className="separator-login-check-content">{t('OU')}</span>
            </div>
            <div className="content-connect-SSO" onClick={handleMicrosoftLogin}>
              <img src="/assets/microsoft.png" alt="logo de microsoft" />
              <p>{t('Continuer avec un compte Microsoft')}</p>
            </div>
            {loginStatus !== null ? (
              <small className="error">{t(`Identifiants invalides`)}</small>
            ) : null}
            {urlError && (
              <small className="error">{t(`${urlError}`)}</small>
            )}
          </form>
          <img src={`${theme === "dark" ? "/assets/logo_white.png" : "/elitlogo.png"}`} alt="Logo d'elit" />
        </section>
      </article>
  );
}
